export default "__VITE_ASSET__Co_OQ$Rk__"